import { Directive, HostListener, Input } from '@angular/core';
import { ModalComponent } from './modal.component';


@Directive({selector: '[CloseModalClick]'})
export class CloseModalClick {

    constructor () {}
    @Input('modal') modal: ModalComponent;


    @HostListener('click', ['$event']) onClick(event: any) {
        if (event.target.className.includes('eva-3-modal')) {
            this.modal.close();
        }
    } 

}